module.exports = __webpack_public_path__ + "static/media/ticker4edited.5bc714b6.png";